import styled from 'styled-components';

export const Recipes = styled.div`
  background: white;
  min-height: 100%;
`
